import { Component, OnInit, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mensaje-pantalla',
  templateUrl: './mensaje-pantalla.component.html',
  styleUrls: ['./mensaje-pantalla.component.scss']
})
export class MensajePantallaComponent implements OnInit {
  @Input () titulo: string = '';
  @Input () mensaje: string = '';
  @Input () verBoton: boolean = true;
  @Output() aceptarEvent = new EventEmitter ();

  constructor() { }

  ngOnInit() {
  }

  aceptar() {
    this.aceptarEvent.emit();
  }
}
